import React from 'react';

const ProjectsImg = ({ theme }) => (
  <svg
    id="a6dc9487-50e2-4fb9-af91-bf1b7118d463"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    width="1103.79"
    height="707.8"
    viewBox="0 0 1103.79 707.8"
  >
    <defs>
      <linearGradient
        id="bd43dd7f-2dfd-4389-bf1e-697a1c0f972b"
        x1="891.82"
        y1="790.72"
        x2="891.82"
        y2="522.9"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="gray" stopOpacity="0.25" />
        <stop offset="0.54" stopColor="gray" stopOpacity="0.12" />
        <stop offset="1" stopColor="gray" stopOpacity="0.1" />
      </linearGradient>
    </defs>
    <title>mind map</title>
    <ellipse
      cx="843.39"
      cy="664.8"
      rx="192"
      ry="43"
      fill={theme.imageHighlight}
      opacity="0.1"
    />
    <g opacity="0.1">
      <path
        d="M673.12,122.89c0,156.1,97.93,282.41,219,282.41"
        transform="translate(-48.1 -96.1)"
        fill={theme.imageHighlight}
      />
    </g>
    <path
      d="M675.52,226.13c-70.75.54-138.73-15.45-203.73-33.27S342.32,155,273,146.82c-44.62-5.27-95.4-4.44-130.47,16-33.75,19.66-43.74,51.89-48.67,81.63-3.71,22.38-5.52,45.86,7.54,66.22C110.42,324.8,126,336.4,137,349.86c38.26,46.83,14.53,107.1-23.41,155.51-17.79,22.71-38.6,44.5-52.1,68.48s-19.18,51.1-5.79,74.6c13.28,23.28,43.54,40,76.09,51.45C197.92,723,275,727.6,350.05,729.06c166.14,3.25,332.71-6.63,498.83-16.5,61.47-3.66,123.22-7.34,183.48-17.15,33.46-5.45,67.92-13.44,91.74-30.61,30.25-21.8,36.68-57.11,15-82.33-36.37-42.29-133-49.68-159-95.53-14.31-25.24-1.57-54.37,17-78.92,39.94-52.64,108.35-100,110-158.62,1.1-40.25-34-79.28-86.68-96.43-55.25-18-130.79-12.79-169.85,21.61C810.34,210,738,225.66,675.52,226.13Z"
      transform="translate(-48.1 -96.1)"
      fill={theme.imageHighlight}
      opacity="0.1"
    />
    <path
      d="M995,127.29V645.7c0,15.42-14.88,28-33.24,28H258.34c-18.36,0-33.23-12.54-33.23-28V127.29c0-15.45,14.87-31.19,33.23-31.19l703.33,1.71C980,97.81,995,111.84,995,127.29Z"
      transform="translate(-48.1 -96.1)"
      fill="#fff"
    />
    <path
      d="M995,127.45v24H225.11v-24A31.35,31.35,0,0,1,256.45,96.1H963.6A31.36,31.36,0,0,1,995,127.45Z"
      transform="translate(-48.1 -96.1)"
      fill={theme.text}
    />
    <circle cx="214.3" cy="27.67" r="11.08" fill="#fa5959" opacity="0.8" />
    <circle cx="246.53" cy="27.67" r="11.08" fill="#fed253" opacity="0.8" />
    <circle cx="278.76" cy="27.67" r="11.08" fill="#8ccf4d" opacity="0.8" />
    <rect
      x="457"
      y="170.7"
      width="70.01"
      height="33.22"
      rx="8.57"
      fill={theme.imageHighlight}
      opacity="0.2"
    />
    <rect
      x="598.84"
      y="170.7"
      width="70.01"
      height="33.22"
      rx="8.57"
      fill={theme.imageHighlight}
      opacity="0.2"
    />
    <polyline
      points="491.81 203.17 561.89 294.68 634.08 202.74"
      fill="none"
      stroke={theme.text}
      strokeMiterlimit="10"
    />
    <rect
      x="508.37"
      y="291.75"
      width="107.03"
      height="50.79"
      rx="8.57"
      opacity="0.1"
    />
    <rect
      x="510.55"
      y="292.79"
      width="102.68"
      height="48.73"
      rx="8.57"
      fill={theme.imageHighlight}
    />
    <line
      x1="492.29"
      y1="170.7"
      x2="491.38"
      y2="138.35"
      fill="none"
      stroke={theme.text}
      strokeMiterlimit="10"
    />
    <polyline
      points="675.22 139.93 634.08 170.7 590.81 139.93"
      fill="none"
      stroke={theme.text}
      strokeMiterlimit="10"
    />
    <rect
      x="456.61"
      y="106.7"
      width="70.01"
      height="33.22"
      rx="8.57"
      fill={theme.imageHighlight}
      opacity="0.2"
    />
    <rect
      x="640.21"
      y="106.7"
      width="70.01"
      height="33.22"
      rx="8.57"
      fill={theme.imageHighlight}
      opacity="0.2"
    />
    <rect
      x="555.81"
      y="106.7"
      width="70.01"
      height="33.22"
      rx="8.57"
      fill={theme.imageHighlight}
      opacity="0.2"
    />
    <line
      x1="561.89"
      y1="341.51"
      x2="561.62"
      y2="430.01"
      fill="none"
      stroke={theme.text}
      strokeMiterlimit="10"
    />
    <path
      d="M609.53,558.59v0Z"
      transform="translate(-48.1 -96.1)"
      fill="none"
      stroke={theme.text}
      strokeMiterlimit="10"
    />
    <polyline
      points="462.42 493.11 561.42 462.48 660.82 492.89"
      fill="none"
      stroke={theme.text}
      strokeMiterlimit="10"
    />
    <rect
      x="526.62"
      y="430.01"
      width="70.01"
      height="33.22"
      rx="8.57"
      fill={theme.imageHighlight}
      opacity="0.2"
    />
    <rect
      x="861.88"
      y="345.12"
      width="70.01"
      height="33.22"
      rx="8.57"
      transform="translate(1210.51 -631.25) rotate(90)"
      fill={theme.imageHighlight}
      opacity="0.2"
    />
    <rect
      x="861.88"
      y="454.76"
      width="70.01"
      height="33.22"
      rx="8.57"
      transform="translate(377.41 1272.15) rotate(-90)"
      fill={theme.imageHighlight}
      opacity="0.2"
    />
    <rect
      x="625.82"
      y="492.66"
      width="70.01"
      height="33.22"
      rx="8.57"
      fill={theme.imageHighlight}
      opacity="0.2"
    />
    <rect
      x="475.52"
      y="588.76"
      width="70.01"
      height="33.22"
      rx="8.57"
      transform="translate(972.95 1114.65) rotate(-180)"
      fill={theme.imageHighlight}
      opacity="0.2"
    />
    <rect
      x="576.46"
      y="588.76"
      width="70.01"
      height="33.22"
      rx="8.57"
      transform="translate(1174.83 1114.65) rotate(-180)"
      fill={theme.imageHighlight}
      opacity="0.2"
    />
    <line
      x1="801"
      y1="320.45"
      x2="832.16"
      y2="374.94"
      fill="none"
      stroke={theme.text}
      strokeMiterlimit="10"
    />
    <line
      x1="735.11"
      y1="319.78"
      x2="767.82"
      y2="319.78"
      fill="none"
      stroke={theme.text}
      strokeMiterlimit="10"
    />
    <line
      x1="613.23"
      y1="317.15"
      x2="702.51"
      y2="319.78"
      fill="none"
      stroke={theme.text}
      strokeMiterlimit="10"
    />
    <line
      x1="832.16"
      y1="265.63"
      x2="801.15"
      y2="320.21"
      fill="none"
      stroke={theme.text}
      strokeMiterlimit="10"
    />
    <rect
      x="732.22"
      y="399.07"
      width="70.01"
      height="33.22"
      rx="8.57"
      transform="translate(1134.8 -447.65) rotate(90)"
      fill={theme.imageHighlight}
      opacity="0.2"
    />
    <rect
      x="797.48"
      y="399.94"
      width="70.01"
      height="33.22"
      rx="8.57"
      transform="translate(1200.94 -512.04) rotate(90)"
      fill={theme.imageHighlight}
      opacity="0.2"
    />
    <rect
      x="288.1"
      y="345.12"
      width="70.01"
      height="33.22"
      rx="8.57"
      transform="translate(636.73 -57.48) rotate(90)"
      fill={theme.imageHighlight}
      opacity="0.2"
    />
    <rect
      x="288.1"
      y="454.76"
      width="70.01"
      height="33.22"
      rx="8.57"
      transform="translate(-196.37 698.37) rotate(-90)"
      fill={theme.imageHighlight}
      opacity="0.2"
    />
    <line
      x1="322.78"
      y1="320.45"
      x2="291.61"
      y2="374.94"
      fill="none"
      stroke={theme.text}
      strokeMiterlimit="10"
    />
    <line
      x1="388.66"
      y1="319.78"
      x2="355.96"
      y2="319.78"
      fill="none"
      stroke={theme.text}
      strokeMiterlimit="10"
    />
    <line
      x1="510.55"
      y1="317.15"
      x2="421.27"
      y2="319.78"
      fill="none"
      stroke={theme.text}
      strokeMiterlimit="10"
    />
    <line
      x1="291.61"
      y1="265.63"
      x2="322.62"
      y2="320.21"
      fill="none"
      stroke={theme.text}
      strokeMiterlimit="10"
    />
    <rect
      x="417.76"
      y="399.07"
      width="70.01"
      height="33.22"
      rx="8.57"
      transform="translate(820.34 -133.18) rotate(90)"
      fill={theme.imageHighlight}
      opacity="0.2"
    />
    <rect
      x="352.49"
      y="399.94"
      width="70.01"
      height="33.22"
      rx="8.57"
      transform="translate(755.94 -67.05) rotate(90)"
      fill={theme.imageHighlight}
      opacity="0.2"
    />
    <path
      d="M156.12,598c0,50.24,31.52,90.9,70.47,90.9"
      transform="translate(-48.1 -96.1)"
      fill="#46455b"
    />
    <path
      d="M226.59,688.89c0-50.81,35.18-91.92,78.65-91.92"
      transform="translate(-48.1 -96.1)"
      fill={theme.imageHighlight}
    />
    <path
      d="M181.66,602.55c0,47.72,20.1,86.34,44.93,86.34"
      transform="translate(-48.1 -96.1)"
      fill={theme.imageHighlight}
    />
    <path
      d="M226.59,688.89c0-64.92,40.66-117.45,90.9-117.45"
      transform="translate(-48.1 -96.1)"
      fill="#46455b"
    />
    <ellipse
      cx="175.43"
      cy="607.19"
      rx="17.52"
      ry="2.96"
      fill={theme.imageHighlight}
      opacity="0.1"
    />
    <path
      d="M211.77,689.53s10-.31,13-2.45,15.37-4.71,16.12-1.27,15,17.11,3.73,17.2-26.22-1.76-29.22-3.59S211.77,689.53,211.77,689.53Z"
      transform="translate(-48.1 -96.1)"
      fill="#a8a8a8"
    />
    <path
      d="M244.83,701.81c-11.28.09-26.21-1.75-29.22-3.59-2.29-1.39-3.2-6.39-3.51-8.7h-.33s.63,8.06,3.64,9.89,17.94,3.68,29.22,3.59c3.26,0,4.38-1.19,4.32-2.9C248.5,701.15,247.26,701.79,244.83,701.81Z"
      transform="translate(-48.1 -96.1)"
      opacity="0.2"
    />
    <path
      d="M1004.32,744.89l-27.67-40.12s-.52-9.93-2.33-12.26-.39-7.48-.39-7.48,1.94-2.84.26-3.09-.26-6.58-.26-6.58l-.13-10.07s1.55-9.67.26-12a3.82,3.82,0,0,1,.13-4.13s1.55-5.55,0-7-1.17-10.06-.78-16.89-2.71-10.71-2.71-11.74-10.22-11.1-10.22-12-6.46-4.64-10.34-5.68-5.82-1.8-5.69-2.32-6.08-2.58-6.08-2.58-5.43-.38-7.5-3.09-8.4-3.5-8.57-3.52c0-.18-.09-.36-.12-.54l-.12-.58c.49-.82.94-1.66,1.35-2.53l.36-.79a11,11,0,0,0,6.36-2,8.7,8.7,0,0,0,3.1-6.19,13.6,13.6,0,0,0-1.51-6.87c-1.14-2.33-2.8-4.73-2.23-7.25.25-1.09.9-2,1.24-3.11a8.19,8.19,0,0,0-.93-6.11c-1-1.87-2.34-3.52-3.43-5.34a20.73,20.73,0,0,1-2.73-7.54,11.88,11.88,0,0,0-1-4.11,7.62,7.62,0,0,0-2.27-2.29,22.65,22.65,0,0,0-13.9-4.21c-3.52.12-7,1.07-10.52.64a38.93,38.93,0,0,1-6.15-1.61c-4.33-1.28-9.34-1.81-13.11.67s-5.28,7.36-7.84,11.18c-2.27,3.38-5.58,6.21-7.3,9.79,0-.07,0-.14.05-.21a12.35,12.35,0,0,0-1,2.61c-.66,2.81-.11,5.75.57,8.55.36,1.45.84,3,2.09,3.82s3,.63,4.52.89c-.06.25-.12.49-.17.74a29.5,29.5,0,0,0,20.5,34.45c0,.26,0,.53,0,.78,0,.77-.06,1.51-.14,2.22h0s-13-2.67-16.49-.87-10.35,3.23-11.38,4.26-3.62.26-5.95,6.32-2.58,12.26-5.56,15.09-4.52,4.78-4.65,6.84.38,2.58-.78,3.23-2.84,3.35-2.33,4.38c0,0,.65,2.58-1.42,3.87a4.31,4.31,0,0,0-1.81,3.87s-.78,2.84-2.59,3.48-3,4.91-3,4.91l-5.86,6.74-11.63-12.86a4.9,4.9,0,0,0-6.91-.35L802,653.51a11.24,11.24,0,0,0-5.71,3.4,15,15,0,0,0-3,4.4l-3.12,2.82a4.8,4.8,0,0,0-1.61,3.44,4.85,4.85,0,0,0,.81,5.32l7.44,8.24,0,.07a13,13,0,0,0-7.2,2.93c-11.12,9.8-11.25,18.83-9.57,23s15.77,20,15.77,20,8.19,10.65,20,16.31h0l-.08.09c-.24.25-.47.52-.7.81l-.19.25-.18.25-.21.31-.16.25-.23.37a2,2,0,0,1-.14.25c-.09.16-.18.33-.26.5l-.09.17c-.11.22-.21.46-.32.7s-.07.18-.1.26-.14.34-.2.52l-.12.33c-.06.16-.11.33-.17.5s-.07.24-.11.37l-.15.56-.09.35c-.08.3-.14.61-.21.93l-.06.37c0,.21-.08.43-.11.66s-.05.31-.07.47,0,.42-.08.64,0,.33-.05.49,0,.49,0,.74,0,.29,0,.45c0,.4,0,.82-.05,1.25-.26,15.09.62,17.28.62,17.28s1.83,4.81,6.87,5.15a8.93,8.93,0,0,0,2.21-.12c6.72-1.16,22.5-3.87,28.06-2.83,3.34.62,9.53-.3,13.93-1.13l1.17-.23.8,2.57,2.56-.7,2.17,1.25,1.37.79c2.55,8.65,12.91,5.7,12.91,5.7l2.46,1.42,25,.64a50.53,50.53,0,0,0,8.84,4.25,8.88,8.88,0,0,0,1.25.27,57.46,57.46,0,0,0,6.95.13c1.92,0,3.4-.13,3.4-.13s-.26-6.77-.62-14.36c9.53-.4,18-1,23.11-1.89C968,772,973.55,759.84,975.6,753.36a60.65,60.65,0,0,1,1.3,8,58.61,58.61,0,0,0,2.07,7,23.67,23.67,0,0,0,2.85,5.16c9.83-3.35,3.88-8.38,1.81-10.57s1.42-4,1.42-4,2.72-1.81,2.46-3.49-.39-3.48,8.4-3.35S1004.32,744.89,1004.32,744.89ZM867.78,662.52c.11.74,1.34,8.68,2.45,10.77a14.37,14.37,0,0,1,.29,4.25c-5.21-.41-10.64-.64-10.64-.64a1.24,1.24,0,0,1,.28.67l-.82-.19c-.38-.09-.78-.18-1.19-.29l9.6-14.59Zm-19,30.25,9,1.43.76.12a30.29,30.29,0,0,0-.47,4.26c0,.13.2.29.49.48a11.67,11.67,0,0,0-.17,2.13c.14.72,4.36,2.26,9.2,3.54-.07.26-.14.5-.2.74h0c-4.27-2.25-11-3.3-11.78-5S832,690.84,832,690.84s-.84-.45-2.28-1.14l6,1.14,1.66-.17A89.92,89.92,0,0,0,848.76,692.77Z"
      transform="translate(-48.1 -96.1)"
      fill="url(#bd43dd7f-2dfd-4389-bf1e-697a1c0f972b)"
    />
    <path
      d="M974.89,750.5s-3.59,21.65-21.79,24.86-78.94,2.56-78.94,2.56-34.73-5-47.29-34.34-20.63-41-9.87-41.53,68.82,19.61,72.15,19.87S978.09,677.32,974.89,750.5Z"
      transform="translate(-48.1 -96.1)"
      fill="#65617d"
    />
    <path
      d="M974.89,750.5s-3.59,21.65-21.79,24.86-78.94,2.56-78.94,2.56-34.73-5-47.29-34.34-20.63-41-9.87-41.53,68.82,19.61,72.15,19.87S978.09,677.32,974.89,750.5Z"
      transform="translate(-48.1 -96.1)"
      opacity="0.05"
    />
    <path
      d="M812,774.59s1.81,4.77,6.8,5.12a8.77,8.77,0,0,0,2.19-.12c6.67-1.16,22.3-3.85,27.81-2.82,3.32.61,9.45-.3,13.82-1.12,2.9-.55,5-1.06,5-1.06s-5.12-17-5.77-17.56-23.06-14-23.06-14L821,741.79H821a9.39,9.39,0,0,0-6,3.54c-1.87,2.27-3.48,6-3.59,12.1C811.1,772.41,812,774.59,812,774.59Z"
      transform="translate(-48.1 -96.1)"
      fill={theme.text}
    />
    <path
      d="M812,774.59s1.81,4.77,6.8,5.12a73.93,73.93,0,0,1-4.82-7l.09-12.43a21.89,21.89,0,0,1,7-18.45H821s-9.35.64-9.61,15.64S812,774.59,812,774.59Z"
      transform="translate(-48.1 -96.1)"
      opacity="0.05"
    />
    <path
      d="M889,747.42l16.53-12.94,26-25.63s-2.81-.14-7.05-.32c-1,.67-4,2.78-4.12,5.35-.12,3.14-7,.22-10.62,2S888.64,740.16,885.56,740s-5.51-1.56-6.79.62l-.09.14Z"
      transform="translate(-48.1 -96.1)"
      opacity="0.1"
    />
    <path
      d="M815,745.32c.59.28,1.19.56,1.79.82,12.56,5.38,28.07,16.66,29.22,18.71.71,1.25,9.7,6.71,16.64,10.8,2.9-.55,5-1.06,5-1.06s-5.12-17-5.77-17.56-23.06-14-23.06-14L821,741.79H821A9.39,9.39,0,0,0,815,745.32Z"
      transform="translate(-48.1 -96.1)"
      opacity="0.1"
    />
    <path
      d="M780.09,708.59c1.67,4.1,15.64,19.86,15.64,19.86s8.84,11.54,21.4,16.92,28.06,16.66,29.22,18.71c.74,1.32,10.75,7.35,17.8,11.49l1.58.92,3.5,2,1.85,1.07s4.29-3.45,8.57-6.92,8.41-6.86,8.48-7c.12-.38,1.79-4.74,1.4-5-.2-.13-1.08-1.91-2.69-4a18.25,18.25,0,0,0-6.53-5.4c-5.9-2.69-8.46-8.82-8.46-8.82s-.56-.4-1.41-.94a17.09,17.09,0,0,0-5.77-2.57c-2.82-.35-8.07-6.12-8.07-6.12s-3.59-2.31-5-5.25-21.22-16.46-23.06-17.73l48.18,30.95,11.53,7.41,16.54-12.94,26-25.63s-3.5-.17-8.58-.39c-12.65-.55-35.1-1.41-37.94-.77a21.45,21.45,0,0,1-7,.46s-6.4.29-10.63-1.94-10.9-3.28-11.67-4.93-23.45-9.61-23.45-9.61-30.88-16.4-41.91-6.66S778.43,704.49,780.09,708.59Z"
      transform="translate(-48.1 -96.1)"
      fill="#65617d"
    />
    <path
      d="M879.67,614.53l4,13.19,5.13,29.74,18.83,1.28,5.46-9,5.44-9s3.39-12,5.83-23.64c2.15-10.28,3.56-20.26,1.22-21.34-2.08-1-3.45-4.43-4.34-8.15-.11-.46-.22-.93-.31-1.39a73.86,73.86,0,0,1-1.25-9.56s-39.47-2.05-34,14.23a25.82,25.82,0,0,1,1.49,8.65,21.8,21.8,0,0,1-.14,2.2A18.45,18.45,0,0,1,879.67,614.53Z"
      transform="translate(-48.1 -96.1)"
      fill="#ee8e9e"
    />
    <path
      d="M871.46,612.35l1.42,22.42,3.2,19.1,3.59,8.84,3.2,48.38s30.9,3.57,38.42-.06a3.33,3.33,0,0,0,1.36-1.07c9.07-13.7,6.1-53.4,6.1-53.4l3.46-25.63-2.31-13.3-5.57-.6-4.29-.45s-1,1.19-2.37,3c-3.8,5-10.79,14.88-10.32,19,.64,5.64-.77,11.4-3,12.3s-4,2.44-4.35.9-.77-1.92-.39-4.1-1.67-8.85-1.67-8.85-3.46-7.81-3.2-11.15-.38-7.17-1.41-8.07-2.43-1.79-1.28-5.89S887,601.67,887,601.67Z"
      transform="translate(-48.1 -96.1)"
      fill="#e3e8f4"
    />
    <path
      d="M912.28,668.36l1.29,38.32,7.4,4.1a3.4,3.4,0,0,0,1.36-1.06c9.07-13.71,6.1-53.41,6.1-53.41l3.46-25.63-2.31-13.3-5.57-.6c2.15-10.28,3.56-20.26,1.22-21.34-2.08-1-3.45-4.43-4.34-8.15h0l-4,27.11s.33,2.45.45,5a14.26,14.26,0,0,1-.32,4.77c-.9,2.31-.26,6.41-.26,6.41-2.31,4.07-3.47,11.61-4,18.89C912,659.13,912.28,668.36,912.28,668.36Z"
      transform="translate(-48.1 -96.1)"
      opacity="0.1"
    />
    <path
      d="M921,586.68s6.46.8,8.51,3.5,7.43,3.07,7.43,3.07,6.15,2,6,2.56,1.79,1.29,5.63,2.31,10.26,4.74,10.26,5.64S969,614.65,969,615.68s3.08,4.87,2.69,11.66-.77,15.38.77,16.79,0,6.92,0,6.92a3.78,3.78,0,0,0-.13,4.1c1.28,2.31-.25,11.92-.25,11.92l.12,10s-1.41,6.28.26,6.54-.26,3.08-.26,3.08-1.41,5.12.39,7.43,2.31,12.17,2.31,12.17l27.42,39.86s.39,7.3-8.33,7.18-8.59,1.66-8.33,3.33-2.43,3.46-2.43,3.46-3.46,1.79-1.41,4,7.94,7.18-1.8,10.51a23.76,23.76,0,0,1-2.82-5.13,58,58,0,0,1-2.05-6.92s-.9-9.74-2.69-11-1.54-7.43-1.54-7.43,2.57-5-1-7.05-55.62-30.89-55.62-30.89L913,667.84s-.9-28.32,4.48-37.81c0,0-.64-4.1.26-6.41s-.13-9.74-.13-9.74Z"
      transform="translate(-48.1 -96.1)"
      fill={theme.text}
    />
    <path
      d="M887.43,602.06s-12.89-2.66-16.35-.86-10.25,3.2-11.28,4.23-3.58.25-5.89,6.28-2.56,12.17-5.51,15-4.49,4.74-4.62,6.79.39,2.56-.76,3.21-2.82,3.33-2.31,4.35,26.65,23.58,26.65,23.58,1.29,8.59,2.44,10.77-1.28,32.16-3.84,34.22,17.3,1.86,17.3,1.86.89-19.68,1.66-20.7-.51-22-.51-22-.13-17.94,1.54-22.68,1.48-20.5,1.48-20.5,1.47-9.46,3.26-11.67S887.43,602.06,887.43,602.06Z"
      transform="translate(-48.1 -96.1)"
      opacity="0.1"
    />
    <path
      d="M887,601.67s-12.88-2.65-16.34-.86S860.44,604,859.42,605s-3.59.26-5.9,6.28-2.56,12.18-5.51,15-4.48,4.74-4.61,6.79.38,2.56-.77,3.2-2.82,3.33-2.31,4.36S867,664.25,867,664.25s1.28,8.58,2.44,10.76-1.29,32.17-3.85,34.22,17.3,1.86,17.3,1.86.9-19.67,1.67-20.7-.52-22-.52-22-.12-17.94,1.54-22.68S887,625.16,887,625.16s1.47-9.46,3.26-11.66S887,601.67,887,601.67Z"
      transform="translate(-48.1 -96.1)"
      fill={theme.text}
    />
    <path
      d="M885.69,590.82a25.82,25.82,0,0,1,1.49,8.65,29.36,29.36,0,0,0,33.72-13.32,73.86,73.86,0,0,1-1.25-9.56S880.18,574.54,885.69,590.82Z"
      transform="translate(-48.1 -96.1)"
      opacity="0.1"
    />
    <path
      d="M866.21,570.57a29.35,29.35,0,1,0,.64-6.1A29.35,29.35,0,0,0,866.21,570.57Z"
      transform="translate(-48.1 -96.1)"
      fill="#ee8e9e"
    />
    <path
      d="M847.37,638.49l-7,2.18s.65,2.56-1.41,3.84a4.29,4.29,0,0,0-1.79,3.85s-.77,2.82-2.56,3.46-2.95,4.87-2.95,4.87l-5.9,6.79s-2.17,1.79-1.79,2.69-2.31,1.15-2.31,1.15L823,690.14l12.18,2.3,7.56-.77,6.15-2.3,5.38-3.21,2.44-6.28,10.76-16.4Z"
      transform="translate(-48.1 -96.1)"
      fill={theme.text}
    />
    <path
      d="M823.41,669.12s-15.64-22.56-27.3-10.38,4.74,31.91,8.59,31.27,22.17-1.67,22.17-1.67Z"
      transform="translate(-48.1 -96.1)"
      fill="#ee8e9e"
    />
    <rect
      x="770.4"
      y="638.26"
      width="81.83"
      height="63.54"
      rx="1.54"
      transform="translate(345.12 -391.66) rotate(27.04)"
      fill={theme.text}
    />
    <rect
      x="777.03"
      y="644.03"
      width="68.78"
      height="51.83"
      transform="translate(345.09 -391.72) rotate(27.04)"
      fill={theme.imageHighlight}
    />
    <circle cx="730.3" cy="557" r="1.13" fill="#e6e8ec" />
    <circle cx="796.61" cy="590.97" r="1.86" fill="#e6e8ec" />
    <path
      d="M813.28,673.86c-.12,16.92,34.86,20.5,34.86,20.5l8.94,1.42,4,.64,1.67-16.54s-1.83-.27-4.12-.8c-3.39-.79-7.78-2.16-8.7-4.07C848.4,671.81,813.41,656.94,813.28,673.86Z"
      transform="translate(-48.1 -96.1)"
      fill="#ee8e9e"
    />
    <path
      d="M866.85,564.47a3.41,3.41,0,0,1,2.15,1c1,1.05,1,2.91,2.33,3.55a2.58,2.58,0,0,0,1.53.18c3.41-.48,5.38-4.33,8.65-5.39a8.67,8.67,0,0,1,5.73.5,4.18,4.18,0,0,1,1.9,1.21c1.1,1.42.33,3.51.84,5.22.7,2.38,3.54,3.33,6,3.64s5.23.48,6.88,2.34a6.27,6.27,0,0,1,1.22,5,3.91,3.91,0,0,0,0,1.83c.68,1.93,4,1.64,4.87.12.64-1.1.45-2,1.94-2.32a6.32,6.32,0,0,1,3.14.54,23.08,23.08,0,0,0,8.11,1.24,29.35,29.35,0,1,0-55.27-18.58Z"
      transform="translate(-48.1 -96.1)"
      opacity="0.1"
    />
    <path
      d="M904.06,582.71a4,4,0,0,1,0-1.84,6.27,6.27,0,0,0-1.22-5c-1.65-1.86-4.42-2-6.88-2.34s-5.3-1.26-6-3.64c-.51-1.71.26-3.8-.84-5.21a4.14,4.14,0,0,0-1.9-1.22,8.67,8.67,0,0,0-5.73-.5c-3.27,1.06-5.24,4.91-8.65,5.39a2.58,2.58,0,0,1-1.53-.18c-1.29-.64-1.34-2.5-2.33-3.55-1.56-1.65-4.51-.58-6.42-1.81-1.24-.8-1.72-2.36-2.07-3.79-.67-2.79-1.22-5.71-.56-8.5,1.11-4.77,5.37-8,8.09-12.11,2.54-3.79,4-8.59,7.77-11.11s8.7-1.94,13-.66a37.88,37.88,0,0,0,6.09,1.59c3.46.43,6.94-.51,10.43-.63a22.46,22.46,0,0,1,13.77,4.18,7.64,7.64,0,0,1,2.25,2.28,11.49,11.49,0,0,1,1,4.08,20.82,20.82,0,0,0,2.71,7.5c1.07,1.8,2.43,3.43,3.4,5.3a8.18,8.18,0,0,1,.92,6.07c-.33,1.05-1,2-1.23,3.09-.57,2.5,1.08,4.89,2.21,7.2a13.55,13.55,0,0,1,1.5,6.83,8.61,8.61,0,0,1-3.08,6.14,11,11,0,0,1-6.49,2A23,23,0,0,1,914,581a6.32,6.32,0,0,0-3.14-.54c-1.49.3-1.3,1.22-1.94,2.32C908.06,584.34,904.74,584.63,904.06,582.71Z"
      transform="translate(-48.1 -96.1)"
      fill={theme.text}
    />
    <path
      d="M888.25,748.19l16.54-12.94,26-25.63s-3.5-.17-8.58-.39a5.63,5.63,0,0,0-1.82,3.5c-.12,3.13-7,.22-10.62,2S888.64,739,885.56,738.86s-5.51-1.56-6.79.62l-.09.14a3.68,3.68,0,0,1-2,1.16Z"
      transform="translate(-48.1 -96.1)"
      opacity="0.1"
    />
    <path
      d="M854.93,747.29l8.31,26.52,1.3,4.16,4-1.08,8.72-2.4,38.84-10.67a33.62,33.62,0,0,0,14-3.73,42.44,42.44,0,0,1,24.14-5.26c5.13.48,10.84-1.73,15.58-10.49,0,0,10.76-31.78-16.41-40.88s-28.46,4.84-28.46,4.84l-.37.23c-1,.67-4,2.78-4.12,5.35-.12,3.14-7,.22-10.62,2S888.64,740.16,885.56,740s-5.51-1.56-6.79.62l-.09.14c-.95,1.31-3.81,1.61-5.69,1.67-1,0-1.78,0-1.78,0l-.24.07-2,.59Z"
      transform="translate(-48.1 -96.1)"
      fill="#65617d"
    />
    <path
      d="M857.08,695.78l4,.64,1.67-16.54s-1.83-.27-4.12-.8C859.23,681.38,857.86,690.3,857.08,695.78Z"
      transform="translate(-48.1 -96.1)"
      opacity="0.1"
    />
    <path
      d="M961.87,618.53s11.92-3.46,9,30.38-25,55.23-25,55.23-25.37,11.15-36.78,9.36a198.28,198.28,0,0,0-19.73-2.18,29,29,0,0,0-11.54-3.08c-6.4-.25-19.86-4.23-20.12-5.51s3.34-20.12,1.8-21.53c0,0,17.94.74,19.73,2s4.36.37,6.28,0,7.82-5.49,19.48-1c0,0,4,.38,5.51-.64s4-.26,4-.26a11.49,11.49,0,0,0,2.79-1.41c.38-.51,3.46,0,3.46,0a1.36,1.36,0,0,0,1.92-.9,8.34,8.34,0,0,1,1.79-2.82s3.46-19.48,10-26.78c0,0,1.92-1.67,1.41-3.72S946.49,614.43,961.87,618.53Z"
      transform="translate(-48.1 -96.1)"
      opacity="0.1"
    />
    <path
      d="M961.56,615.93s11.92-3.46,9,30.38-25,55.23-25,55.23-25.38,11.15-36.78,9.36S889,708.72,889,708.72a29,29,0,0,0-11.53-3.08c-6.41-.25-19.86-4.23-20.12-5.51s3.33-20.12,1.79-21.53c0,0,17.94.74,19.74,2s4.36.36,6.28,0,7.82-5.5,19.48-1c0,0,4,.38,5.51-.64s4-.26,4-.26a11.29,11.29,0,0,0,2.78-1.41c.38-.51,3.46,0,3.46,0a1.36,1.36,0,0,0,1.92-.9,8.59,8.59,0,0,1,1.8-2.82s3.46-19.48,10-26.78c0,0,1.93-1.67,1.41-3.72S946.18,611.83,961.56,615.93Z"
      transform="translate(-48.1 -96.1)"
      fill={theme.text}
    />
    <path
      d="M869,743.08l16.92,20.48c.07-.06.11-.1.11-.12.13-.38,1.79-4.74,1.41-5s-3.33-6.67-9.23-9.36a17.49,17.49,0,0,1-7.24-6.6Z"
      transform="translate(-48.1 -96.1)"
      opacity="0.1"
    />
    <path
      d="M869.23,778.52l1.85,1.07s4.29-3.45,8.57-6.92,8.41-6.86,8.48-7c.12-.38,1.79-4.74,1.4-5-.2-.13-1.08-1.91-2.69-4-11.48-3.22-4.17,4.75-3.2,5.11,0,0-14-3.2-14.74,12A18,18,0,0,0,869.23,778.52Z"
      transform="translate(-48.1 -96.1)"
      opacity="0.1"
    />
    <path
      d="M883.38,785l2.44,1.41,24.73.64a50,50,0,0,0,8.76,4.21,7.66,7.66,0,0,0,1.24.28,58.55,58.55,0,0,0,6.89.13c1.9,0,3.36-.13,3.36-.13s-1.17-31.2-2-34.48c-.42-1.57-2.5-1.22-4.54-.44a30,30,0,0,0-4.43,2.24s-10.51,1-12.18,1.93-6.4-.52-9.35,0-8.2-3.47-8.2-3.47c-14.36-4.74-6.28,4.1-5.26,4.48,0,0-14-3.2-14.73,12S883.38,785,883.38,785Z"
      transform="translate(-48.1 -96.1)"
      fill={theme.text}
    />
    <path
      d="M919.14,772.92c.27,6.46,5.3,14.48,8.3,18.72,1.9,0,3.36-.13,3.36-.13s-1.17-31.2-2-34.48c-.42-1.57-2.5-1.22-4.54-.44C921.73,761.24,918.92,767.72,919.14,772.92Z"
      transform="translate(-48.1 -96.1)"
      fill="#565387"
    />
    <path
      d="M919.14,772.92c.27,6.46,5.3,14.48,8.3,18.72,1.9,0,3.36-.13,3.36-.13s-1.17-31.2-2-34.48c-.42-1.57-2.5-1.22-4.54-.44C921.73,761.24,918.92,767.72,919.14,772.92Z"
      transform="translate(-48.1 -96.1)"
      opacity="0.1"
    />
    <path
      d="M914.91,773.78c1.7,6.23,1.68,13.22,4.4,17.45a7.66,7.66,0,0,0,1.24.28,58.55,58.55,0,0,0,6.89.13c1.9,0,3.36-.13,3.36-.13s-1.17-31.2-2-34.48c-.42-1.57-2.5-1.22-4.54-.44a30,30,0,0,0-4.43,2.24S912.73,765.8,914.91,773.78Z"
      transform="translate(-48.1 -96.1)"
      opacity="0.05"
    />
    <path
      d="M829.58,710.55s12.29,4,22.7,18.16Z"
      transform="translate(-48.1 -96.1)"
      opacity="0.1"
    />
    <g opacity="0.1">
      <path
        d="M929.41,556.77c0,.1,0,.19-.07.28a10.86,10.86,0,0,1-.43,1.07A8.1,8.1,0,0,1,929.41,556.77Z"
        transform="translate(-48.1 -96.1)"
      />
      <path
        d="M859.9,550.56a12,12,0,0,1,1-2.59c-.07.22-.13.44-.19.67-.65,2.79-.11,5.71.57,8.49.35,1.44.83,3,2.07,3.8,1.91,1.22,4.86.16,6.42,1.81,1,1,1,2.91,2.33,3.55a2.58,2.58,0,0,0,1.53.18c3.4-.48,5.38-4.33,8.65-5.39a8.67,8.67,0,0,1,5.73.5,4.17,4.17,0,0,1,1.9,1.22c1.09,1.41.33,3.5.83,5.21.71,2.38,3.55,3.32,6,3.64s5.23.48,6.88,2.34a6.27,6.27,0,0,1,1.22,5,3.78,3.78,0,0,0,0,1.83c.68,1.92,4,1.64,4.87.12.64-1.1.44-2,1.94-2.33a6.44,6.44,0,0,1,3.14.55,23.26,23.26,0,0,0,8.28,1.24,11,11,0,0,0,6.49-2,7.54,7.54,0,0,0,2-2.42,8.21,8.21,0,0,1-2.77,4.34,11,11,0,0,1-6.49,2A23,23,0,0,1,914,581a6.32,6.32,0,0,0-3.14-.54c-1.49.3-1.3,1.22-1.94,2.32-.87,1.52-4.19,1.81-4.87-.11a4,4,0,0,1,0-1.84,6.27,6.27,0,0,0-1.22-5c-1.65-1.86-4.42-2-6.88-2.34s-5.3-1.26-6-3.64c-.51-1.71.26-3.8-.84-5.21a4.19,4.19,0,0,0-1.9-1.22,8.67,8.67,0,0,0-5.73-.5c-3.27,1.06-5.25,4.91-8.65,5.39a2.58,2.58,0,0,1-1.53-.18c-1.29-.64-1.34-2.5-2.33-3.55-1.56-1.65-4.51-.58-6.42-1.81-1.24-.8-1.72-2.36-2.07-3.79C859.79,556.27,859.25,553.35,859.9,550.56Z"
        transform="translate(-48.1 -96.1)"
      />
    </g>
    <path
      d="M931.4,653.13c-2.35,3.17-5,6.1-7.11,9.45s-3.54,7.27-3.11,11.19c2.15-2.2,3.13-5.25,4.49-8,2.29-4.68,5.72-8.65,8.62-13,.55-.82,4.09-5.57,2.3-5.8C935.11,646.8,932.2,652.05,931.4,653.13Z"
      transform="translate(-48.1 -96.1)"
      opacity="0.1"
    />
  </svg>
);

export default ProjectsImg;
